function dateTime() {
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  var d = new Date();
  var day = days[d.getDay()];
  var hr = d.getHours();
  var min = d.getMinutes();
  if (min < 10) {
    min = "0" + min;
  }
  var ampm = "am";
  if (hr > 12) {
    hr -= 12;
    ampm = "pm";
  }
  var date = d.getDate();
  var month = months[d.getMonth()];
  var year = d.getFullYear();
  var x =
    day + " " + hr + ":" + min + ampm + " " + date + " " + month + " " + year;
  return x;
}

export default {
  async setTasks(context, payload) {
    if (context.getters.isLoaded === payload) {
      return;
    }
    const token = context.rootGetters["auth/token"];
    const response = await fetch(
      `https://pmsystem-34a73-default-rtdb.firebaseio.com/tasks/${payload}.json?auth=` +
        token
    );
    const responseData = await response.json();
    if (!response.ok) {
      const error = new Error(
        responseData.message || "Failed to load Task List"
      );
      throw error;
    }
    const tasks = [];
    for (const key in responseData) {
      const task = {
        taskId: responseData[key].taskId,
        task: responseData[key].task,
        description: responseData[key].description,
        feedback: responseData[key].feedback,
        mode: responseData[key].mode,
        date: responseData[key].date,
        assignTo: responseData[key].assignTo,
        id: key,
      };
      if (task.feedback === undefined) {
        task.feedback = [];
      }
      tasks.push(task);
    }
    context.commit("setTask", tasks);
  },

  async addTask(context, payload) {
    const taskData = {
      taskId: payload.projectId,
      task: payload.task,
      description: payload.description,
      assignTo: payload.assignTo,
      feedback: [{}],
      mode: payload.mode,
      date: dateTime(),
    };
    const token = context.rootGetters["auth/token"];
    const response = await fetch(
      `https://pmsystem-34a73-default-rtdb.firebaseio.com/tasks/${payload.projectId}.json?auth=` +
        token,
      {
        method: "POST",
        body: JSON.stringify(taskData),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(
        responseData.message || "Failed to add task try again"
      );
      throw error;
    }
    context.commit("addTask", taskData);
  },

  async updateMode(context, payload) {
    const serverPath = payload.taskId + "/" + payload.id;
    const token = context.rootGetters["auth/token"];
    const response = await fetch(
      `https://pmsystem-34a73-default-rtdb.firebaseio.com/tasks/${serverPath}/mode.json?auth=` +
        token,
      {
        method: "PUT",
        body: JSON.stringify(payload.mode),
      }
    );

    const responseData = await response.json();
    if (!response.ok) {
      const error = new Error(responseData.message || responseData.error);
      throw error;
    }
    context.commit("updateMode", payload);
  },

  async addReplie(context, payload) {
    const user = context.rootGetters["auth/userId"];
    const serverLink = payload.taskId + "/" + payload.id;
    const token = context.rootGetters["auth/token"];
    const submitAble = {
      Commentdate: dateTime(),
      comment: payload.replie,
      feedBy: user,
    };
    const response = await fetch(
      `https://pmsystem-34a73-default-rtdb.firebaseio.com/tasks/${serverLink}/feedback.json?auth=` +
        token,
      {
        method: "POST",
        body: JSON.stringify(submitAble),
      }
    );
    const responseData = await response.json();
    if (!response.ok) {
      const error = new Error(responseData.message || responseData.error);
      throw error;
    }
    const updateAble = {
      ...submitAble,
      taskId: payload.id,
      name:responseData.name
    };
    context.commit("addReplie", updateAble);
  },
};
